import Cookies from 'js-cookie';
import { IS_PUBLIC, IS_VKT_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export function initMyTeam() {
    const hasMyTeamCookie = !!Cookies.get('isMyTeam');
    if (IS_VKT_WEBVIEW && !hasMyTeamCookie && !IS_PUBLIC) {
        Cookies.set('isMyTeam', 'true', { path: '/' });
    }

    const userAgent = window.navigator.userAgent;
    if (!userAgent.includes('QtWebEngine')) {
        Cookies.remove('isMyTeam', { path: '/' });
    }
}
